import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import LOG_APPLICATION_ERROR from '../graph/mutations/log-application-error';

export type LogApplicationErrorDispatch = {
  sendApplicationErrorLog: (data: any) => void;
};

const useApplicationError = (): LogApplicationErrorDispatch => {
  const [logApplicationError] = useMutation(LOG_APPLICATION_ERROR);

  const sendApplicationErrorLog = useCallback(async (data) => {
    try {
      await logApplicationError({
        variables: { data: { ...data, timestamp: new Date().toISOString() } },
      });
    } catch (error) {
      console.error(error);
    }
  }, []);

  return {
    sendApplicationErrorLog,
  };
};

export default useApplicationError;
